import { render, staticRenderFns } from "./SatisfactionTab.vue?vue&type=template&id=010b5be7&"
import script from "./SatisfactionTab.vue?vue&type=script&lang=js&"
export * from "./SatisfactionTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports